import { useQuery, UseQueryOptions } from 'react-query';

import { FunnelApiClient } from '~/api';
import { Product } from '~/hooks/useAppLead';

export const useProductQuery = (
  options?: Omit<UseQueryOptions<{ products: Product[] }, unknown, { products: Product[] }>, 'queryKey' | 'staleTime'>,
) => {
  return useQuery<{ products: Product[] }, unknown, { products: Product[] }>(['product'], {
    queryFn: () => {
      return FunnelApiClient<unknown, { products: Product[] }>({
        method: 'GET',
        url: `/product`,
      });
    },
    staleTime: Infinity,
    ...options,
  });
};
